import React from "react"
import { Link } from "react-router-dom"
import {
  Card,
  CardBody,
  Table,
  CardTitle,
} from "reactstrap"

export const expandRow = {
  renderer: row => (
    <React.Fragment>
      <Card>
        <CardBody>
          <CardTitle className="mb-3">Order Summary</CardTitle>

          <div className="container-fluid">
            <div className="row">
              {/* Left column – Order Summary */}
              <div className="col-md-6">
                <div className="row mb-2">
                  <div className="col-sm-4 fw-bold">Price</div>
                  <div className="col-sm-8">{row.price}</div>
                </div>

                <div className="row mb-2">
                  <div className="col-sm-4 fw-bold">Placement</div>
                  <div className="col-sm-8">{row.placement}</div>
                </div>

                <div className="row mb-2">
                  <div className="col-sm-4 fw-bold">Blending</div>
                  <div className="col-sm-8">{row.blending}</div>
                </div>

                <div className="row mb-2">
                  <div className="col-sm-4 fw-bold">Height</div>
                  <div className="col-sm-8">{row.height}</div>
                </div>

                <div className="row mb-2">
                  <div className="col-sm-4 fw-bold">Width</div>
                  <div className="col-sm-8">{row.width}</div>
                </div>

                <div className="row mb-2">
                  <div className="col-sm-4 fw-bold">Urgent</div>
                  <div className="col-sm-8">{row.rush ?? ""}</div>
                </div>

                <div className="row mb-2">
                  <div className="col-sm-4 fw-bold">Format</div>
                  <div className="col-sm-8">{row.requiredFormat}</div>
                </div>

                <div className="row mb-2">
                  <div className="col-sm-4 fw-bold">PO</div>
                  <div className="col-sm-8">{row.po}</div>
                </div>

                <div className="row mb-2">
                  <div className="col-sm-4 fw-bold">Colors</div>
                  <div className="col-sm-8">{row.numberOfColors}</div>
                </div>

                <div className="row mb-2">
                  <div className="col-sm-4 fw-bold">Instructions</div>
                  <div
                    className="col-sm-8 text-wrap"
                    style={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}
                  >
                    {row.additionalInstructions ?? ""}
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col-sm-4 fw-bold">Price Status</div>
                  <div className="col-sm-8">
                    {row.hasOwnProperty("paymentStatus")
                      ? row.paymentStatus === false
                        ? "Receivable"
                        : "Received"
                      : ""}
                  </div>
                </div>
              </div>

              {/* Right column – Images */}
              <div className="col-md-6">
                <div className="fw-bold mb-2">Order Images</div>

                {row.fileName && (
                  <div className="mb-2">
                    <a href={row.uploadfileName} target="_blank" rel="noreferrer">
                      {row.fileName}
                    </a>
                  </div>
                )}
                {row.fileName2 && (
                  <div className="mb-2">
                    <a href={row.uploadfileName2} target="_blank" rel="noreferrer">
                      {row.fileName2}
                    </a>
                  </div>
                )}

                <div className="mb-2 fw-bold">Order Processing Images</div>

                <div className="row">
                  {"imagesUploads" in row?.processingData &&
                    row.processingData.imagesUploads?.map((item, i) => (
                      <div
                        key={i}
                        className="col-3 text-center mb-3"
                        style={{ cursor: "pointer" }}
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        title={item.imageName || `Image ${i + 1}`}
                      >
                        <a href={item.filePath} target="_blank" rel="noopener noreferrer">
                          <div className="border p-1 mb-1">
                            <img
                              src={
                                item.url ||
                                "/file.jpg"
                              }
                              width={50}
                              height={50}
                              alt={`Upload ${i}`}
                              className="img-thumbnail d-block mx-auto"
                              onError={(e) => {
                                e.target.src =
                                  "/file.jpg";
                              }}
                            />
                          </div>
                          <div
                            className="small text-wrap"
                            style={{
                              width: "100px",
                              textAlign: "center",
                              wordBreak: "break-word",
                              margin: "0 auto"

                            }}
                          >
                            {item.imageName || `Image ${i + 1}`}
                          </div>          </a>
                      </div>
                    ))}
                </div>
              </div>

            </div>
          </div>

        </CardBody>
      </Card>

    </React.Fragment>
  )
  ,
  showExpandColumn: true,       // ✅ show the expand (+) column
  expandByColumnOnly: true,     // ✅ expand ONLY when clicking the +/–
  expandHeaderColumnRenderer: ({ isAnyExpands }) => {
    return isAnyExpands ? '👇' : '👉'; // optional custom header icon
  },
  expandColumnRenderer: ({ expanded }) => {
    return expanded ? (<span style={{ cursor: "pointer" }}>➖</span>) : (<span style={{ cursor: "pointer" }}>➕</span>); // ✅ icons for expand/collapse
  }
}